export default function readInputSourceMapFile(): never {
  throw new Error(
    "Reading input source map files is not supported in browsers",
  );
}
